import { helper } from "@ember/component/helper"
import { padStart } from "lodash-es"

export interface CanonicalTimeParams {
  hour: number
  minute: number
  id?: string
}

export default function formatTime(time: CanonicalTimeParams, standardOrMilitary: string): string {
  let { hour, minute } = time
  let formattedMinute = padStart(minute.toString(), 2, "0")
  // This is probably an option we want to have a flag for.
  if (hour === 23 && minute === 59) return "End of Day"
  if (standardOrMilitary === "12hrs") {
    let meridian = hour < 12 ? "am" : "pm"
    let idHour
    if (hour === 0) {
      idHour = "12"
    } else if (hour > 12) {
      idHour = (hour - 12).toString()
    } else {
      idHour = hour.toString()
    }
    return `${idHour}:${formattedMinute}${meridian}`
  } else {
    let formattedHour = padStart(hour.toString(), 2, "0")
    return `${formattedHour}:${formattedMinute}`
  }
}

// We only have this so we can get typing with glint.
const formatTimeHelper = helper((params: [CanonicalTimeParams, string]) => {
  return formatTime(params[0], params[1])
})

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "format-time": typeof formatTimeHelper
  }
}
